export default {
	name: 'Customers',
	singular: 'Customer',
	icon: 'tablet-alt',
    ownView: 'Customers',
	slug:  'reseller-customers',
	isCustom: true,
	access: ['reseller']
}